import { mockComponent } from 'bloko/common/setupMockComponents';

const { TipTheme, TipLayer, TipPlacement, TipProvider } = jest.requireActual('bloko/blocks/drop/Tip/HoverTip.js');
export { TipTheme, TipLayer, TipPlacement, TipProvider };

export default mockComponent('DropTipHoverTip', null, { withChildren: true });
